module.exports = __webpack_public_path__ + "img/guanyuwomen.2dfd11c1.png";